import type { Budget } from '../types/Budget'

export const mockBudgets: Budget[] = [
  // ===== 템플릿 예산 (year: null, month: null) - 모든 년도/월에 적용 =====
  // 대분류 예산
  { id: 'budget_001', categoryId: 'cat_food', amount: 600000, year: null, month: null, isActive: true },
  { id: 'budget_002', categoryId: 'cat_transport', amount: 150000, year: null, month: null, isActive: true },
  { id: 'budget_003', categoryId: 'cat_shopping', amount: 200000, year: null, month: null, isActive: true },
  { id: 'budget_004', categoryId: 'cat_housing', amount: 1200000, year: null, month: null, isActive: true },
  { id: 'budget_005', categoryId: 'cat_medical', amount: 100000, year: null, month: null, isActive: true },
  { id: 'budget_006', categoryId: 'cat_leisure', amount: 300000, year: null, month: null, isActive: true },
  { id: 'budget_007', categoryId: 'cat_education', amount: 150000, year: null, month: null, isActive: true },
  { id: 'budget_008', categoryId: 'cat_event', amount: 200000, year: null, month: null, isActive: true },
  { id: 'budget_009', categoryId: 'cat_finance', amount: 400000, year: null, month: null, isActive: true },

  // 소분류 예산 (주요 항목)
  // 식비 소분류 (합: 60만원)
  { id: 'budget_001_01', categoryId: 'cat_food_meal', parentBudgetId: 'budget_001', amount: 300000, year: null, month: null, isActive: true },
  { id: 'budget_001_02', categoryId: 'cat_food_cafe', parentBudgetId: 'budget_001', amount: 200000, year: null, month: null, isActive: true },
  { id: 'budget_001_03', categoryId: 'cat_food_delivery', parentBudgetId: 'budget_001', amount: 50000, year: null, month: null, isActive: true },
  { id: 'budget_001_04', categoryId: 'cat_food_dining', parentBudgetId: 'budget_001', amount: 50000, year: null, month: null, isActive: true },

  // 교통 소분류 (합: 13만원 ≤ 15만원)
  { id: 'budget_002_01', categoryId: 'cat_transport_public', parentBudgetId: 'budget_002', amount: 100000, year: null, month: null, isActive: true },
  { id: 'budget_002_02', categoryId: 'cat_transport_taxi', parentBudgetId: 'budget_002', amount: 30000, year: null, month: null, isActive: true },

  // 쇼핑 소분류 (합: 18만원 ≤ 20만원)
  { id: 'budget_003_01', categoryId: 'cat_shopping_clothes', parentBudgetId: 'budget_003', amount: 100000, year: null, month: null, isActive: true },
  { id: 'budget_003_02', categoryId: 'cat_shopping_living', parentBudgetId: 'budget_003', amount: 50000, year: null, month: null, isActive: true },
  { id: 'budget_003_03', categoryId: 'cat_shopping_cosmetics', parentBudgetId: 'budget_003', amount: 30000, year: null, month: null, isActive: true },

  // 주거 소분류 (합: 117만원 ≤ 120만원)
  { id: 'budget_004_01', categoryId: 'cat_housing_rent', parentBudgetId: 'budget_004', amount: 1000000, year: null, month: null, isActive: true },
  { id: 'budget_004_02', categoryId: 'cat_housing_maintenance', parentBudgetId: 'budget_004', amount: 120000, year: null, month: null, isActive: true },
  { id: 'budget_004_03', categoryId: 'cat_housing_utility', parentBudgetId: 'budget_004', amount: 50000, year: null, month: null, isActive: true },

  // 의료 소분류 (합: 8만원 ≤ 10만원)
  { id: 'budget_005_01', categoryId: 'cat_medical_hospital', parentBudgetId: 'budget_005', amount: 50000, year: null, month: null, isActive: true },
  { id: 'budget_005_02', categoryId: 'cat_medical_pharmacy', parentBudgetId: 'budget_005', amount: 30000, year: null, month: null, isActive: true },

  // 여가 소분류 (합: 18만원 ≤ 30만원)
  { id: 'budget_006_01', categoryId: 'cat_leisure_movie', parentBudgetId: 'budget_006', amount: 50000, year: null, month: null, isActive: true },
  { id: 'budget_006_02', categoryId: 'cat_leisure_subscription', parentBudgetId: 'budget_006', amount: 30000, year: null, month: null, isActive: true },
  { id: 'budget_006_03', categoryId: 'cat_leisure_travel', parentBudgetId: 'budget_006', amount: 100000, year: null, month: null, isActive: true },

  // 교육 소분류 (합: 10만원 ≤ 15만원)
  { id: 'budget_007_01', categoryId: 'cat_education_books', parentBudgetId: 'budget_007', amount: 50000, year: null, month: null, isActive: true },
  { id: 'budget_007_02', categoryId: 'cat_education_lecture', parentBudgetId: 'budget_007', amount: 50000, year: null, month: null, isActive: true },

  // 경조사 소분류 (합: 15만원 ≤ 20만원)
  { id: 'budget_008_01', categoryId: 'cat_event_wedding', parentBudgetId: 'budget_008', amount: 100000, year: null, month: null, isActive: true },
  { id: 'budget_008_02', categoryId: 'cat_event_gift', parentBudgetId: 'budget_008', amount: 50000, year: null, month: null, isActive: true },

  // 금융 소분류 (합: 34만원 ≤ 40만원)
  { id: 'budget_009_01', categoryId: 'cat_finance_insurance', parentBudgetId: 'budget_009', amount: 320000, year: null, month: null, isActive: true },
  { id: 'budget_009_02', categoryId: 'cat_finance_fee', parentBudgetId: 'budget_009', amount: 20000, year: null, month: null, isActive: true },

  // ===== 특정 월 예산 예시 (2025년 12월 전용) =====
  // 12월은 연말이라 식비 예산 증액 (60만원 → 80만원)
  { id: 'budget_001_dec', categoryId: 'cat_food', amount: 800000, year: 2025, month: 12, isActive: true },
  { id: 'budget_001_01_dec', categoryId: 'cat_food_meal', parentBudgetId: 'budget_001_dec', amount: 400000, year: 2025, month: 12, isActive: true },
  { id: 'budget_001_02_dec', categoryId: 'cat_food_cafe', parentBudgetId: 'budget_001_dec', amount: 300000, year: 2025, month: 12, isActive: true },
]

// 템플릿 총 예산 계산 (대분류만 합산)
export const totalTemplateBudget = mockBudgets
  .filter(b => b.isActive && !b.parentBudgetId && b.year === null && b.month === null)
  .reduce((sum, b) => sum + b.amount, 0)
